export const VideoDevices: string[] = [
  "7500",
  "x30",
  "x50",
  "x70",
  "eagleeye",
  "e70",
  "studio",
  "p5",
  "p15",
  "p21"
];

export const VoiceDevices: string[] = [
  "trio",
  "ccx",
  "vvx",
  "blackwire",
  "da75",
  "da85",
  "encorepro",
  "sync",
  "voyager"
];
